import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../global.service';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { LocalStorageService } from '../storage.service';
import { BusinessContextService } from '../business-context.service';

export interface CreatePortionPayload {
  name: string;
  categoryUuids: string[];
}

export interface PortionDTO {
  id?: number;
  name: string;
  enabled?: boolean;
  uuid: string;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class PortionsService extends ApiService {
  constructor(
    public override http: HttpClient,
    public override config: ConfigService,
    public override localStorageService: LocalStorageService,
    handler: HttpBackend,
    private bizCtx: BusinessContextService,
  ) {
    super(http, config, localStorageService, handler);
  }

  private getBusiness(): string { return this.bizCtx.getSelected() || this.CUSTOMER; }

  getPortions(): Observable<PortionDTO[]> {
    const business = this.getBusiness();
    return this.get<PortionDTO[]>(`${this.URL}/portions/${business}`);
  }

  createPortion(payload: CreatePortionPayload): Observable<PortionDTO> {
    const business = this.getBusiness();
    return this.create<PortionDTO>(`${this.URL}/portions/${business}`, payload);
  }
}
